import { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';

import { OrderService as Service } from './OrderService';
import { RegisterInvoiceService } from '../../service/invoice/RegisterInvoiceService';
import { CurrencyService } from '../danh-muc/tien-te/CurrencyService';
import { AppConfigService } from '../../service/AppConfigService';

import { useToolbar } from '../../shared/hooks/Toolbar';
import { useDataTable } from '../../shared/hooks/DataTable';
// import { useDialogImportExcel } from './item/DialogImportExcel';
// import { DialogCrup } from './component/DialogCrup';
// import { DialogCrupXangDau } from './component/DialogCrupXangDau';
import { DialogView } from './components/DialogView';
// import { DialogViewMulti } from './component/DialogViewMulti';
// import { DialogCancel } from './component/DialogCancel';
// import { DialogSendEmail } from './component/DialogSendEmail';
// import { DialogViewTransferLog } from './component/DialogViewTransferLog';
// import { DialogSignInvoice } from './component/DialogSignInvoice';
import { DialogViewHistory } from './components/DialogViewHistory';
import { TenantSettingService } from '../he-thong/tham-so-he-thong/TenantSettingService';
import { Sign, useSign } from '../../shared/component/Sign';
import { ConfirmDialogService } from '../../AppConfirmDialog';
import { ROLE } from '../../Constant';
import { AppStorage } from '../../service/UserStorage';
import EventEmitter from '../../utils/EventEmitter';
// import { useDialogSyncInvoice } from './item/DialogSyncInvoice';
// import { useDialogChangeInvoiceSerial } from './item/DialogChangeSerial';
// import { useDialogTaxAuthStatus } from './item/DialogTaxAuthStatus';
import { FormatDisplay } from '../../shared/format';
import { DialogCrupBanVang } from './components/DialogCrupBanVang';
import { Dialog } from 'primereact/dialog';
import { TenantCompanyService } from '../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import _ from 'lodash';
import { DialogCrup } from './components/DialogCrup';
import { DialogCrupHoKinhDoanh } from './components/DialogCrupHoKinhDoanh';
import { DialogKaraokeNhaHang } from './components/DialogKaraokeNhaHang';

export const List = () => {
  let permissionString = AppStorage.get('pk');
  let permissions = [];
  let selectedRecords = null;
  let functionActions = [];
  let mitileSignActions = [];
  let errorProcessingAction = [];
  const header = 'Đơn hàng';
  const deleteRole = ROLE.INVOICE_MANAGEMENT_DELETE;
  const createRole = ROLE.INVOICE_MANAGEMENT_CREATE;
  const editRole = ROLE.INVOICE_MANAGEMENT_EDIT;
  const cloneRole = ROLE.INVOICE_MANAGEMENT_COPY;
  const importRole = ROLE.INVOICE_MANAGEMENT_FEATURES_UPLOADEXCEL;
  const exportRole = ROLE.INVOICE_MANAGEMENT_FEATURES_DOWNLOADXML;
  const dataKey = 'id';

  const { search, state } = useLocation();
  const [showIconHitoryChange, setShowIconHitoryChange] = useState(false);
  const [registerId, setRegisterId] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [requiredParams, setRequiredParams] = useState(null);

  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);

  const [displayView, setDisplayView] = useState(false);
  const [displayCrup, setDisplayCrup] = useState(false);
  const [displayCrupXangDau, setDisplayCrupXangDau] = useState(null);
  const [displayCancel, setDisplayCancel] = useState(false);
  const [transferLogItem, setTransferLogItem] = useState(false);
  const [displayTransferLog, setDisplayTransferLog] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [displayHistoryItem, setDisplayHistoryItem] = useState(null);
  const [displayHistory, setDisplayHistory] = useState(false);

  const [columns, setColumns] = useState([]);
  const [columnsState, setColumnsState] = useState(0);
  const [columnConfigOrigin, setColumnConfigOrigin] = useState(null);
  const [columnConfig, setColumnConfig] = useState(null);
  const [columnConfigSum, setColumnConfigSum] = useState(null);
  const [footerColumnGroup, setFooterColumnGroup] = useState(null);
  const [actionPermision, setActionPermision] = useState([]);
  const [showIconView, setShowIconView] = useState(true);
  const [showIconCopy, setShowIconCopy] = useState(true);
  const [showIconPrint, setShowIconPrint] = useState(true);
  const [showIconSign, setShowIconSign] = useState(true);
  const [systemStatus, setSystemStatus] = useState(["", "Ký hóa đơn xml lỗi", "Hoàn tác, Lỗi trong quá trình gửi hóa đơn ký số điện tử, Vui lòng ký và gửi lại hóa đơn", "Hoàn tác, Lỗi trong quá trình gửi hóa đơn tới cơ quan thuế, Vui lòng ký và gửi lại hóa đơn"]);
  const [isOpenDialogCreate, setIsOpenDialogCreate] = useState(false)
  const [isOpenDialogCreateInvoice, setIsOpenDialogCreateInvoice] = useState(false)
  const [isOpenDialogSignInvoice, setIsOpenDialogSignInvoice] = useState(false)
  const [displayPreview, setDisplayPreview] = useState(false)
  const preview = useRef<HTMLIFrameElement>(null)
  const [createdInvoice, setCreatedInvoice] = useState([])
  const [isInit, setIsInit] = useState(true)

  useEffect(() => {
    setDisableIconAction();
    TenantSettingService.getList({ key: TenantSettingService.key.BAT_LUU_LICH_SU_THAY_DOI_HOA_DON }).then(({ items, totalCount }) => {
      if (totalCount > 0) {
        setShowIconHitoryChange(items[0].value === 'C');
      }
    }).finally(() => {

      CurrencyService.getList({ maxResultCount: 1000 }).then(({ items }) => {
        setCurrencies(items);
      });
    });
  }, []);

  useEffect(() => {
    TenantCompanyService.get(AppStorage.get('__tenant')).then(data => {
      document.title = data.name + '-' + data.taxCode;
      AppStorage.set('tenantInfo', JSON.stringify(data));
      // setTenantData(data);
      EventEmitter.emit("changeTenantInfo", data);
    });
  }, []);

  useEffect(() => {
    setColumnsState(0);
    setRequiredParams(undefined);
    setSelectedItems(null);
    loadColumnConfig();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    refreshToolbar();
  }, [registerId]);

  useEffect(() => {
    if (columnConfigOrigin) {
      const _columns = [];
      columnConfigOrigin.forEach(columnOrigin => {
        if (columnOrigin.active) {
          let defaultHard: any = {};
          switch (columnOrigin.dataType) {
            case 'int32':
            case 'numeric':
              defaultHard = {
                dataType: 'custom', customCell(rowData: any): any {
                  return FormatDisplay.number(rowData[columnOrigin.field], FormatDisplay.getFractionDigits(rowData));
                }, style: { justifyContent: 'end' }
              }
              break;
            case 'dateTime':
              defaultHard = { dataType: 'date' };

              if (columnOrigin.matchMode) {
                defaultHard.filterType = 'range-date';
                if (columnOrigin.field === 'orderDate') {
                  defaultHard.filterField = 'fromDate@toDate';
                } else {
                  defaultHard.filterField = columnOrigin.filterField;
                }
                defaultHard.matchMode = columnOrigin.matchMode;
              }
              break;
          }
          const hard = hardColumns[columnOrigin.field] ? hardColumns[columnOrigin.field] : defaultHard;
          _columns.push({
            field: columnOrigin.field,
            header: columnOrigin.header,
            width: columnOrigin.width,
            sum: columnOrigin.sum,
            ...hard,
            matchMode: columnOrigin.matchMode
          });
        }
      });
      setColumns(_columns);
      setColumnsState(Date.now);
    }
  }, [columnConfigOrigin]); // eslint-disable-line react-hooks/exhaustive-deps

  const hardColumns = {
    orderStatus: {
      filterType: 'multiselect', filterOptions: Service.orderStatus, dataType: 'custom', customCell(rowData: any): any {
        return <span className={`order-status order-status-${rowData.orderStatus}`}>{Service.orderStatus[rowData.orderStatus - 1]?.label}</span>;
      }
    },
    invoiceStatus: {
      filterType: 'multiselect', filterOptions: Service.invoiceStatuses, dataType: 'custom', customCell(rowData: any): any {
        return <span className={`invoice-status invoice-status-${rowData.invoiceStatus}`}>{Service.invoiceStatuses[rowData.invoiceStatus]?.label}</span>;
      }
    },
    sendTaxStatus: {
      filterType: 'multiselect', filterOptions: Service.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
        if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
          return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{Service.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
        }
        if ([1].includes(rowData.sendTaxStatus) && rowData.systemStatus > 0) {
          return <span className={`send-tax-status send-tax-status-1`} title={`${systemStatus[rowData.systemStatus]}`}>{Service.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
        }
        return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{Service.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
      }
    },
    buyerLegalName: {
      minWidth: 250, dataType: 'custom', customCell(rowData: any): any {
        return rowData.buyerLegalName || rowData.buyerDisplayName;
      }
    },
    sendEmail: { filterType: 'boolean', dataType: 'boolean' }
  };

  const setDisableIconAction = () => {
    // setShowIconView(permissions.includes(ROLE.INVOICE_MANAGEMENT_EDIT));
    // setShowIconCopy(permissions.includes(ROLE.INVOICE_MANAGEMENT_COPY));
    // setShowIconPrint(permissions.includes(ROLE.INVOICE_MANAGEMENT_PRINT));
    // setShowIconSendEmail(permissions.includes(ROLE.INVOICE_MANAGEMENT_EMAIL));
    // setShowIconSign(permissions.includes(ROLE.INVOICE_MANAGEMENT_SIGN));
  }
  const loadColumnConfig = () => {
    AppConfigService.getColumnConfig({
      TypeConfig: 'Invoice',
    }).then(config => {
      const _configColumns = config.items || [];
      setColumnConfig(_configColumns);
      setColumnConfigOrigin(_configColumns);
    });
  }


  const { render: renderDataTable, refreshLazyData, reloadLazyData, items, selectedItems, setSelectedItems, showSelection, clearItems } = useDataTable({
    header,
    dataKey,
    columns,
    columnsState,
    indexColumnWidth: 40,
    actionColumnWidth: 300,
    heightCalc: 190,
    requiredParams,
    getList: (params) => {
      if (isInit && state) {
        setIsInit(false)
        return Service.getList({ ...state, ...params });

      } else {
        return Service.getList(params);

      }
    },
    initActions: (items) => {
      if (items) {
        items.forEach(item => {
          item.actions = [];
          if (showIconView) {
            item.actions.push({ icon: 'pi pi-pencil', className: 'p-button-warning', title: 'Chỉnh sửa', disabled: [2, 3, 4, 5].includes(item.sendTaxStatus), command: () => update(item) });
          }
          if (showIconCopy) {
            item.actions.push({ icon: 'pi pi-copy', className: '', title: 'Sao chép', command: () => clone(item) });
          }
          if (showIconPrint) {
            item.actions.push({ icon: 'pi pi-print', className: '', title: 'Xem in hóa đơn', command: () => view(item) });
            JSON.parse(AppStorage.get('tenantInfo'))?.companyType === '01' && item.actions.push({ icon: 'pi-file-o', className: '', title: 'Xem in giấyđảm bảo', command: () => viewSecurity(item) });
          }
          if (showIconSign) {
            item.actions.push({
              icon: 'pi pi-tag', className: '', title: 'Tạo hóa đơn', disabled: item.invoiceId || createdInvoice.includes(item.id), command: () => {
                if (item && (
                  (Array.isArray(item) && item.length > 0) ||
                  (!Array.isArray(item) && Object.keys(item).length > 0)
                )) {
                  if (
                    (Array.isArray(item) && item.some(item => item.orderStatus === 1 || item.orderStatus === 3)) ||
                    (!Array.isArray(item) && ((item as any).orderStatus === 1 || (item as any).orderStatus === 3))
                  ) {
                    ConfirmDialogService.showInvalid('Chỉ được tạo hóa đơn ở trạng thái chưa xuất hóa đơn');
                    return;
                  }
                  setSelectedItems(item)

                  setIsOpenDialogCreateInvoice(true);
                } else {
                  ConfirmDialogService.showInvalid('Bạn cần chọn đơn hàng trước khi tạo hóa đơn');
                }

              }
            });
          }
          if (showIconSign) {
            item.actions.push({ icon: 'pi pi-sync', className: '', title: 'Cập nhật hóa đơn', disabled: !(item.invoiceId !== undefined && item.invoiceId !== null && item.sendTaxStatus !== 4), command: () => updateInvoice({ items: [{ invoiceId: item.invoiceId, orderId: item.id }] }) });
          }
          if (showIconHitoryChange) {
            item.actions.push({ icon: 'pi pi-clock', className: '', title: 'Xem lịch sử', command: () => viewHistory(item) });
          }
          item.actions.push({
            icon: 'pi pi-fw pi-user-edit', className: '', title: 'Ký', command: () => {
              if (item && (
                (Array.isArray(item) && item.length > 0) ||
                (!Array.isArray(item) && Object.keys(item).length > 0)
              )) {
                if (
                  (Array.isArray(item) && item.some(item => item.sendTaxStatus !== 1)) ||
                  (!Array.isArray(item) && (item as any).sendTaxStatus !== 1)
                ) {
                  ConfirmDialogService.showInvalid('Không thể ký hóa đơn đang ở trạng thái chờ ký');
                  return;
                }
                setSelectedItems(item)

                setIsOpenDialogSignInvoice(true);
              } else {
                ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi ký hóa đơn');
              }

            }, disabled: item.sendTaxStatus !== 1
          });
          item.actions.push({
            icon: 'pi pi-print',
            className: '',
            title: 'In đơn hàng',
            command: () => {
              setDisplayPreview(true)
              return Service.printOrder(item.id).then((data) => {
                if (preview.current && preview.current.contentWindow) {
                  preview.current.contentWindow.document.open();
                  preview.current.contentWindow.document.write(`${data.pagehmtl[0].trim()}`);
                }
              })
            },
          });
        });
      }
    },
    footerColumnGroup
  });

  useEffect(() => {
    if (columns) {
      let hasSumCol = false;
      columns.forEach(column => {
        if (column.sum) {
          hasSumCol = true;

          if (items) {
            let sumValue = 0;
            items.forEach(item => {
              if (typeof item[column.sum] === 'number' && !Number.isNaN(item[column.sum])) {
                sumValue += item[column.sum];
              }
            });
            column.sumValue = sumValue;
          }
        }
      });
      if (hasSumCol) {
        setFooterColumnGroup(<ColumnGroup>
          <Row>
            <Column style={{ minWidth: '40px', maxWidth: '40px', border: 0 }} />
            {
              columns.map((_column, index) => {
                if (_column.sum) {
                  return <Column key={index} footer={FormatDisplay.number(_column.sumValue)} style={{ justifyContent: 'end', minWidth: `${_column.width}px`, maxWidth: `${_column.width}px` }} />
                }
                return <Column key={index} style={{ minWidth: `${_column.width}px`, maxWidth: `${_column.width}px`, border: 0, borderLeft: '1px solid #dee2e6' }} />
              })
            }
            <Column style={{ minWidth: '199px', maxWidth: '199px' }} className="table-actions" />
          </Row>
        </ColumnGroup>);
      } else {
        setFooterColumnGroup(null);
      }
    } else {
      setFooterColumnGroup(null);
    }
  }, [columns, items]); // eslint-disable-line react-hooks/exhaustive-deps

  const { renderSign, sign } = useSign({ onComplete: refreshLazyData });

  const downloadXml = () => {
    if (selectedItems && !Array.isArray(selectedItems) && selectedItems['id']) {
      downloadSingleFileXml();
    } else {
      downloadMutileFileXml();
    }
  }

  const downloadSingleFileXml = () => {
    Service.downloadInvoiceXml(selectedItems['id']).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `${selectedItems['buyerTaxCode']}_${selectedItems['invoiceSerial']}_${selectedItems['invoiceNumber']}.xml`;
      link.click();
    });
  }

  const downloadMutileFileXml = () => {
    let InvoiceIdArray;
    if (Array.isArray(selectedItems) && selectedItems.length) {
      InvoiceIdArray = selectedItems.map(({ id, buyerTaxCode, invoiceSerial, invoiceNumber }) => `${id}_${buyerTaxCode}_${invoiceSerial}_${(invoiceNumber ?? id)}`);
    } else {
      InvoiceIdArray = [`${selectedItems['id']}_${selectedItems['buyerTaxCode']}_${selectedItems['invoiceSerial']}_${selectedItems['invoiceNumber'] ?? selectedItems['id']}`];
    }

    if (InvoiceIdArray && InvoiceIdArray.length) {
      Sign({
        "CommandName": "ExportInvoiceXML",
        "InvoiceIdArray": InvoiceIdArray
      }).then(() => {
        refreshLazyData();
      });
    }
  }

  const update = (item) => {
    setSelectedItems(item);
    setIsOpenDialogCreate(true);
  }

  const clone = (item) => {
    Service.get(item.id).then(result => {
      setSelectedItems({ ...result, orderDate: new Date() })
      setIsOpenDialogCreate(true)
    })
  }

  const view = (item) => {
    item.viewSecurity = false;
    setSelectedItems(item);
    setDisplayView(true);
  }

  const viewSecurity = (item) => {
    item.viewSecurity = true;
    setSelectedItems(item);
    setDisplayView(true);
  };

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({ id }) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Ký');
      return;
    }

    sign({
      "CommandName": "SignInvoices",
      "InvoiceIdArray": InvoiceIdArray
    });
  }

  const chunkArray = (array, size) => {
    const result = []
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size))
    }
    return result
  }


  const viewHistory = (item) => {
    setDisplayHistoryItem(item);
    setDisplayHistory(true);
  }

  const send = (item) => {
    setSelectedItems(item);
  }

  const createInvoice = (item) => {
    setSelectedItems([]);
    setIsOpenDialogCreateInvoice(true);
    // Service.createInvoice(item).then(res => { refreshLazyData(); });
  }

  const updateInvoice = (item) => {
    Service.updateInvoice(item).then(res => { refreshLazyData(); });
  }

  useEffect(() => {
    const reloadData = () => {
      refreshLazyData();
    }

    const changeSerial = (changeSerialData) => {
      const itemChange = registerInvoices.find((t) => t.symbolCode == changeSerialData.invoiceSerialRepalce);
      Service.createChangeSerial(changeSerialData).then(res => {
        refreshLazyData();
      });
    }
    const showDialogSendEmail = (dataInvoice) => {
      setSelectedItems(dataInvoice);
    };

    const eventsListner = EventEmitter.addListener("reloadInvoiceData", reloadData);
    const eventsChangeSerial = EventEmitter.addListener("changeInvoiceSerial", changeSerial);
    const eventsshowDialogSendEmail = EventEmitter.addListener("showDialogSendEmail", showDialogSendEmail);
    return () => {
      eventsListner.removeListener("reloadInvoiceData", reloadData);
      eventsChangeSerial.removeListener("changeInvoiceSerial", changeSerial);
      eventsshowDialogSendEmail.removeListener("showDialogSendEmail", showDialogSendEmail);
    }
  });

  const syncByWebApp = (data) => {
    Service.createSyncInvoice(data).then(res => {
      refreshLazyData();
    });
  };

  const [manyActions, setManyActions] = useState([]);

  useEffect(() => {
    const actionsOther = [];
    if (showSelection) {
      if (showIconSign) {
        actionsOther.push();
      }
    }

    setManyActions(actionsOther);
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const op = useRef(null);

  const onRowReorder = e => {
    setColumnConfig(e.value);
  }

  const restoreColumnConfig = () => {
    AppConfigService.restoreColumnConfig({
      TypeConfig: 'Invoice'
    }).then(() => {
      loadColumnConfig();
    });
  }
  const saveColumnConfig = () => {
    AppConfigService.setColumnConfig({
      TypeConfig: 'Invoice',
      detail: columnConfig
    }).then(() => {
      loadColumnConfig();
    });
  }

  let itemFunctionAction = [];
  // if (permissions.includes(ROLE.INVOICE_MANAGEMENT_FEATURES_UPLOADEXCEL)) {
  //   itemFunctionAction.push({ label: 'Nhận Excel', command: showImportDialog });
  // }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_FEATURES_DOWNLOADXML)) {
    itemFunctionAction.push({ label: 'Tải XML', command: downloadXml });
  }

  if (itemFunctionAction && itemFunctionAction.length) {
    functionActions.push({
      label: 'Chức năng', icon: 'pi pi-fw pi-th-large', className: 'iam-toolbar iam-toolbar-help',
      items: [[
        {
          label: '',
          items: [...itemFunctionAction]
        }
      ]]
    });
  }

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey,
    createRole,
    editRole,
    cloneRole,
    deleteRole,
    importRole,
    exportRole,
    create: () => {
      setSelectedItems(null);
      setIsOpenDialogCreate(true)
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    deleteItems: (ids) => {
      return Service.deleteBatch({ orderIds: ids });
    },
    validateDeleteItems: (items) => {
      let _valid = true, ivs = [];
      if (items['id']) {
        ivs = [items];
      } else {
        ivs = [...items];
      }
      for (const iv of ivs) {
        if ([2, 3, 4, 5].includes(iv.sendTaxStatus)) {
          _valid = false;
          ConfirmDialogService.showInvalid('Bạn không được Xóa hóa đơn Đã ký, Đã gửi, Thành Công, Có lỗi');
          break;
        }
      }
      return _valid;
    },

    otherActions: [
      ...manyActions,
      ...functionActions,
      ...mitileSignActions,
      ...errorProcessingAction,
      {
        label: 'Tạo hóa đơn',
        icon: 'pi pi-fw pi-user-edit',
        className: 'iam-toolbar',
        command: () => {
          if (selectedItems && (
            (Array.isArray(selectedItems) && selectedItems.length > 0) ||
            (!Array.isArray(selectedItems) && Object.keys(selectedItems).length > 0)
          )) {
            if (
              (Array.isArray(selectedItems) && selectedItems.some(item => item.orderStatus === 1)) ||
              (!Array.isArray(selectedItems) && (selectedItems as any).orderStatus === 1)
            ) {
              ConfirmDialogService.showInvalid('Không thể tạo hóa đơn cho đơn hàng đã xuất hóa đơn');
              return;
            }
            setIsOpenDialogCreateInvoice(true);
          } else {
            ConfirmDialogService.showInvalid('Bạn cần chọn đơn hàng trước khi tạo hóa đơn');
          }
        },
        disabled: !selectedItems
      },
      {
        label: 'Ký gửi CQT',
        icon: 'pi pi-fw pi-user-edit',
        className: 'iam-toolbar',
        command: () => {
          if (selectedItems && (
            (Array.isArray(selectedItems) && selectedItems.length > 0) ||
            (!Array.isArray(selectedItems) && Object.keys(selectedItems).length > 0)
          )) {
            if (
              (Array.isArray(selectedItems) && selectedItems.some(item => item.sendTaxStatus !== 1)) ||
              (!Array.isArray(selectedItems) && (selectedItems as any).sendTaxStatus !== 1)
            ) {
              ConfirmDialogService.showInvalid('Không thể ký hóa đơn đang ở trạng thái chờ ký');
              return;
            }
            setIsOpenDialogSignInvoice(true);
          } else {
            ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi ký hóa đơn');
          }
        },
        disabled: !selectedItems
      },
    ],
    endMenu: <Fragment>
      <Button icon="pi pi-cog" className="p-button-rounded p-button-outlined p-button-secondary" onClick={e => op.current.toggle(e)} />
      <OverlayPanel ref={op} style={{ width: '600px' }}>
        <DataTable value={columnConfig} reorderableRows onRowReorder={onRowReorder}
          scrollable scrollHeight="50vh" responsiveLayout="scroll" className="p-fluid" size={'small'}>
          <Column body={(rowData, { rowIndex }) =>
            <Checkbox checked={rowData.active} onChange={e => onColumnConfigChange(rowIndex, 'active', e.checked)} />}
            style={{ minWidth: '2em', maxWidth: '2em' }} />
          <Column field="header" header="Tên cột" />
          <Column field="width" header="Độ rộng (px)" body={(rowData, { rowIndex }) =>
            <InputNumber locale={FormatDisplay.locales} value={rowData.width} min={10} max={500} onValueChange={e => onColumnConfigChange(rowIndex, 'width', e.value)} />}
            style={{ minWidth: '8em', maxWidth: '8em' }} />
          <Column field="sum" header="Tổng cộng" body={(rowData, { rowIndex }) =>
            <Dropdown value={rowData.sum} options={columnConfigSum} onChange={e => onColumnConfigChange(rowIndex, 'sum', e.value)} showClear style={{ width: '100%' }} />}
            style={{ minWidth: '17em', maxWidth: '17em' }} />
          <Column rowReorder style={{ minWidth: '4em', maxWidth: '4em' }} />
        </DataTable>
        <div className="text-right mt-4">
          <Button label="Lấy lại mặc định" className="p-button-text p-button-sm mr-2" onClick={restoreColumnConfig} />
          <Button label="Lưu" icon="pi pi-check" className="p-button-sm" onClick={saveColumnConfig} />
        </div>
      </OverlayPanel>
    </Fragment>
  });

  const onColumnConfigChange = (rowIndex, field, value) => {
    const _columnConfig = [...columnConfig];
    _columnConfig[rowIndex][field] = value;
    setColumnConfig(_columnConfig);
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      <DialogViewHistory display={displayHistory} setDisplay={setDisplayHistory} selectedItem={displayHistoryItem} />
      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedItems}
        setDisplayCancel={setDisplayCancel} setInvoiceStatus={setInvoiceStatus} setDisplayCrup={setDisplayCrup} sign={sign} />
      {(() => {
        const tenantInfo = JSON.parse(AppStorage.get('tenantInfo'));
        switch (tenantInfo?.companyType) {
          case '01':
            return (
              <DialogCrupBanVang display={isOpenDialogCreate} onHide={() => {
                setSelectedItems(null);
                setIsOpenDialogCreate(false);
                refreshLazyData();
              }}
                selectedInvoice={selectedItems}
              />
            );
          case '02':
            return (
              <DialogCrupHoKinhDoanh display={isOpenDialogCreate} onHide={() => {
                setSelectedItems(null);
                setIsOpenDialogCreate(false);
                refreshLazyData();
              }}
                selectedInvoice={selectedItems}
              />

            );
          case '03':
            return (
              <DialogCrup display={isOpenDialogCreate} onHide={() => {
                setSelectedItems(null);
                setIsOpenDialogCreate(false);
                refreshLazyData();
              }}
                selectedInvoice={selectedItems}
              />
            );
          case '04':
            return (
              <DialogKaraokeNhaHang display={isOpenDialogCreate} onHide={() => {
                setSelectedItems(null);
                setIsOpenDialogCreate(false);
                refreshLazyData();
              }}
                selectedInvoice={selectedItems}
              />
            );
          default:
            return (
              <DialogCrup display={isOpenDialogCreate} onHide={() => {
                setSelectedItems(null);
                setIsOpenDialogCreate(false);
                refreshLazyData();
              }}
                selectedInvoice={selectedItems}
              />
            );
        }
      })()}

      <Dialog
        header={"Xác nhận tạo hóa đơn"}
        footer={() =>
          <div>
            <Button className='p-button-text' label="Không" autoFocus onClick={() => { setIsOpenDialogCreateInvoice(false) }} />
            <Button label="Tạo" autoFocus onClick={() => {
              const invoiceIds = Array.isArray(selectedItems)
                ? selectedItems.map(item => item.id)
                : [(selectedItems as any).id];
              Service.createInvoice({ items: invoiceIds }).then(res => { refreshLazyData(); });
              setIsOpenDialogCreateInvoice(false);
              setSelectedItems(null);
            }} />
          </div>
        }
        visible={isOpenDialogCreateInvoice}
        onHide={() => setIsOpenDialogCreateInvoice(false)}
      >
        <div className='flex gap-3 pt-2 align-items-center '>
          <div className='pi pi-exclamation-circle text-4xl'></div>
          <p>Bạn chắc chắn muốn tạo hóa đơn này?</p>
        </div>
      </Dialog>

      <Dialog
        header={"Ký hóa đơn"}
        footer={() =>
          <div>
            <Button className='p-button-text' label="Không" autoFocus onClick={() => { setIsOpenDialogSignInvoice(false) }} />
            <Button label="Ký" autoFocus onClick={() => {
              console.log(selectedItems);
              const invoiceIds = Array.isArray(selectedItems)
                ? selectedItems.map(item => item.id)
                : [(selectedItems as any).id];
              Service.signInvoice({ items: invoiceIds }).then(res => { refreshLazyData(); });
              setIsOpenDialogSignInvoice(false);
              setSelectedItems(null);
            }} />
          </div>
        }
        visible={isOpenDialogSignInvoice}
        onHide={() => setIsOpenDialogSignInvoice(false)}
      >
        <div className='flex gap-3 pt-2 align-items-center '>
          <div className='pi pi-exclamation-circle text-4xl'></div>
          <p>Bạn chắc chắn muốn ký hóa đơn này?</p>
        </div>
      </Dialog>

      <Dialog visible={displayPreview} style={{ width: '890px' }} draggable={false} resizable={true} position="top"
        onHide={() => setDisplayPreview(false)} className="view-invoice">
        <iframe className="template-preview" ref={(el) => preview.current = el} title="template-preview" />
      </Dialog>
    </Fragment>
  )
}
